import {
	OptionRelatedInstituteSettings,
	ProctoringOption,
	ProctoringOptionProfileV2,
} from "@verity/proctoring-option/types";
import { ExemptedStudent, VerityInstituteSettings } from "../../types/common";
import styles from "./ViewDetailsModal.module.css";
import { CoreBackButton, CoreTitleCardDescription } from "../../core";
import i18nPackage from "../../i18n/i18n";
import { DEFAULT_PROCTORING_CONFIGURATION_OPTIONS, enforceConfiguration } from "@verity/proctoring-option";
import { ProctoringOptionCategory } from "../proctoring-options";
import { ProctoringDataType } from "../hooks/state/useSettingsState";
import { ConfigurationBlock } from "../confirmation";
import {
	AccommodationStudentBlock,
	AccommodationNotesBlock,
	AccommodationTypeBlock,
} from "../confirmation/blocks/AccommodationBlocks";
import { PlatformBlock, ProfileBlock } from "../confirmation/blocks/ProctoringBlocks";
import { ConfirmationSummaryRow } from "../confirmation/EditQuizSummary";

export type ViewDetailsModalProps = {
	backButtonText?: string;
	onClose: () => void;
	profile?: ProctoringOptionProfileV2;
	exemptedStudent?: ExemptedStudent;
	configuration?: {
		verityInstituteSettings: VerityInstituteSettings;
		optionRelatedInstituteSettings: OptionRelatedInstituteSettings | undefined;
		proctoringData: Pick<ProctoringDataType, "applications" | "extensions">;
		proctoringOption: Partial<ProctoringOption>;
		allowedCategories?: ProctoringOptionCategory[];
	};
	description?: string;
};

export default function ViewDetailsModal({
	configuration,
	exemptedStudent,
	profile,
	onClose,
	description,
	backButtonText,
}: ViewDetailsModalProps) {
	return (
		<div className={styles.viewDetailsModalPage}>
			<div className={styles.titleSection}>
				<CoreBackButton onBack={onClose} text={backButtonText} padding="0" />
				{description && <CoreTitleCardDescription>{description}</CoreTitleCardDescription>}
			</div>
			<ConfirmationSummaryRow>
				{exemptedStudent && (
					<>
						<AccommodationStudentBlock
							name={
								exemptedStudent.name
									? exemptedStudent.name
									: i18nPackage.t("editQuizPage.accommodationStep.unknownStudent")
							}
						/>
						<AccommodationTypeBlock
							type={exemptedStudent.proctoringOptionProfileId ? "customProfile" : "notProctored"}
						/>
					</>
				)}
				{profile && <ProfileBlock profile={profile} />}
				{configuration && (
					<PlatformBlock
						platformOptions={
							enforceConfiguration(
								DEFAULT_PROCTORING_CONFIGURATION_OPTIONS,
								profile?.proctoringOption ?? {},
								configuration.verityInstituteSettings,
								configuration.optionRelatedInstituteSettings,
							).proctoringOptions
						}
						optionRelatedInstituteSettings={configuration.optionRelatedInstituteSettings}
					/>
				)}
			</ConfirmationSummaryRow>
			{configuration && (
				<ConfigurationBlock
					verityInstituteSettings={configuration.verityInstituteSettings}
					optionRelatedInstituteSettings={configuration.optionRelatedInstituteSettings}
					option={configuration.proctoringOption}
					applications={configuration.proctoringData.applications}
					extensions={configuration.proctoringData.extensions}
					allowedCategories={configuration.allowedCategories}
				/>
			)}
			{exemptedStudent && <AccommodationNotesBlock notes={exemptedStudent.accommodationNotes} />}
		</div>
	);
}
